export interface PendingProfileUpdate {
    field?: "name" | "mobile" | "photo";
    value?: string;
    step?: number;
}

export const startProfileUpdateFlow = (
    field: "name" | "mobile" | "photo",
    setPendingProfile: (data: PendingProfileUpdate | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {
    if (field === "name") {
        setPendingProfile({ field: "name", step: 1 });
        pushAIChat("Sure! What should your new name be?");
        speak("What should your new name be?");
        return;
    }

    if (field === "mobile") {
        setPendingProfile({ field: "mobile", step: 1 });
        pushAIChat("Sure! What is your new mobile number?");
        speak("What is your new mobile number?");
        return;
    }

    if (field === "photo") {
        setPendingProfile({ field: "photo", step: 1 });

        pushAIChat("Sure! Please upload your new profile photo.");
        speak("Please upload your new profile photo.");

        // 🔥 Trigger file uploader in drawer automatically
        window.dispatchEvent(new CustomEvent("ai-open-file-upload"));

        return;
    }
};

export const processPendingProfileUpdate = (
    text: string,
    pending: PendingProfileUpdate,
    setPendingProfile: (data: PendingProfileUpdate | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {

    // NAME UPDATE
    if (pending.field === "name") {
        const cleanName = text.replace(/[^a-zA-Z ]/g, "").trim();
        window.dispatchEvent(
            new CustomEvent("ai-update-profile", { detail: { field: "name", value: cleanName } })
        );
        pushAIChat(`Updating your name to ${cleanName}`);
        speak(`Updating your name to ${cleanName}`);
        setPendingProfile(null);
        return;
    }


    // MOBILE UPDATE
    if (pending.field === "mobile") {
        const mobile = text.replace(/[^0-9]/g, "");
        if (mobile.length < 10) {
            pushAIChat("Please provide a valid mobile number.");
            speak("Please provide a valid mobile number.");
            return;
        }
        window.dispatchEvent(
            new CustomEvent("ai-update-profile", { detail: { field: "mobile", value: mobile } })
        );
        pushAIChat(`Updating your mobile number to ${mobile}`);
        speak(`Updating your mobile number to ${mobile}`);
        setPendingProfile(null);
        return;
    }


    // PHOTO UPDATE
    if (pending.field === "photo") {
        pushAIChat("Please upload your new profile photo.");
        speak("Please upload your new profile photo.");

        window.dispatchEvent(new CustomEvent("ai-open-file-upload"));

        return;
    }
};
